import { rootApi } from 'root-api'

const TAG_TYPES = ['REPORT']

const api = rootApi.enhanceEndpoints({ addTagTypes: TAG_TYPES }).injectEndpoints({
  endpoints: (build) => ({
    fetchPersonsReport: build.query({
      query: ({
        organization,
        currentUserId,
        start,
        end,
        status,
        users = [],
        teams = [],
        groups = [],
        eventTypes = [],
        ...params // additional optional params such as groupBy, sort
      }) => ({
        url: '/api/reports/persons',
        params: {
          organization,
          currentUserId,
          start,
          end,
          status,
          ...(users?.length > 0 ? { users } : {}),
          ...(teams?.length > 0 ? { teams } : {}),
          ...(groups?.length > 0 ? { groups } : {}),
          ...(eventTypes?.length > 0 ? { eventTypes } : {}),
          ...params
        }
      }),
      extraOptions: {
        handleErrors: false
      },
      providesTags: ['REPORT']
    }),
  })
})

export const {
  useFetchPersonsReportQuery
} = api
